module.exports = __webpack_public_path__ + "static/media/logoGITHUB.b8e4fbd3.svg";